import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Checkbox, Icon } from 'semantic-ui-react';
import { formValueSelector, reduxForm, reset } from 'redux-form';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button, Grid } from 'semantic-ui-react';

import { errorToast } from 'Common/ToastHelper';
import { MANAGE_PROCESS_ORDER_FORM_NAME } from 'Common/FormEnum';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_SERVER,
  ReactTableWrapperColumnProperties,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { ManageProcessOrderEnum } from 'Common/FieldEnum';
import { NotificationMessage } from 'Components';
import { resetForm } from 'State/forms/actions';
import { ManageProcessOrderStatusEnum } from 'Common/Constants/Enumeration/ManageProcessOrderEnum';
import {
  setNotificationDialog,
  setYesNoDialogProps,
} from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import * as SecuritySelectors from 'Common/Security/state/selectors';
import { Filter, Main } from 'Containers';
import { SORT_DIRECTION } from 'State/paging/helpers';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';

import ManageProcessOrderComponent from './../../components/manageProcessOrderList/ManageProcessOrder';
import {
  clearOrderGridData,
  clearAllErrors,
  resetTablePage,
  getOrderList,
  getSiteList,
  manageOrderDelete,
  manageOrderClose,
  getPrintManageProcessOrderPreviewData,
  setToDateMin,
  setFromDateMax,
} from '../../state/manageProcessOrder/actions';
import {
  manageProcessOrders,
  clearProcessMessage,
} from './../../state/processOrder/actions';
import { setConsolidateApiModelData } from './../../state/consolidate/actions';
import * as CreateEditOrderActions from '../../state/createEditOrder/actions';
import * as CreateEditOrderSelectors from '../../state/createEditOrder/selectors';
import {
  getClosedOrderedItem,
  ManageProcessOrderPrintOptions,
} from './../../helper';

const currentDate = moment();

class ManageProcessOrderContainer extends Component {
  static propTypes = {
    manageOrderListData: PropTypes.object.isRequired,
    siteListData: PropTypes.array.isRequired,
    beginDT: PropTypes.string,
    endDT: PropTypes.string,
    site: PropTypes.string,
    viewStatusOptions: PropTypes.string,
    printOptions: PropTypes.string,
    orderTypeDetails: PropTypes.array,
    loading: PropTypes.bool.isRequired,
    printLoading: PropTypes.bool.isRequired,
    processLoading: PropTypes.bool.isRequired,
    closing: PropTypes.bool.isRequired,
    initialValues: PropTypes.object,
    printOptionsValue: PropTypes.string,
    gridPreferenceLoading: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    processId: PropTypes.string,
    cancelProcessError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    orderTypesData: PropTypes.array.isRequired,
    orderTypesLoading: PropTypes.bool.isRequired,
    orderTypesError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    resetPageOnDataChange: PropTypes.bool.isRequired,
    fromDateMax: PropTypes.object.isRequired,
    toDateMin: PropTypes.object.isRequired,
    processMessageError: PropTypes.string,
    processDuplicateIds: PropTypes.array.isRequired,
  };
  static defaultProps = {
    beginDT: '',
    endDT: '',
    site: '',
    viewStatusOptions: ManageProcessOrderStatusEnum.OPEN,
    printOptions: '',
    orderTypeDetails: [],
    initialValues: {},
    printOptionsValue: ManageProcessOrderEnum.ItemCode,
    processId: '',
    cancelProcessError: null,
    orderTypesError: null,
    processMessageError: '',
  };

  defaultSort = [
    {
      SortName: ManageProcessOrderEnum.DeliveryDate,
      SortDirection: SORT_DIRECTION.DESC,
    },
  ];

  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      showCloseModel: false,
      showDeleteModel: false,
      selectedOrder: null,
      showDeleteConfirm: false,
      showCloseConfirm: false,
      showProcessModel: false,
      showProcessConfirm: false,
      showConsolidateConfirm: false,
      showConsolidateCloseOrderModal: false,
      selectedOrders: [],
      orderTypeDetails: [],
      expanded: [],
      columns: [
        {
          expander: true,
          Header: '',
          width: 40,
          accessor: 'expander',
          id: 'expander',
          Expander: ({ isExpanded, original: { IsConsolidatedOrder } }) => {
            let props = {};

            if (isExpanded) {
              props = { rotated: 'clockwise' };
            }

            return (
              IsConsolidatedOrder && <Icon name="caret right" {...props} />
            );
          },
          sortable: false,
          visibility: false,
          show: true,
        },
        {
          Header: (currentRows) => {
            const { selectedOrders } = this.state;
            const dataObjs = currentRows.data;
            let filteredData = [];
            let checkAllIds = [];
            _.forEach(dataObjs, (obj) => {
              const id = obj[ManageProcessOrderEnum.Id]
                ? obj[ManageProcessOrderEnum.Id]
                : obj._original[ManageProcessOrderEnum.Id];
              if (selectedOrders.indexOf(id) === -1) {
                filteredData.push(id);
              } else {
                checkAllIds.push(id);
              }
            });
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    dataObjs.length > 0 &&
                    checkAllIds.length === dataObjs.length
                  }
                  onChange={(e, { checked }) => {
                    e.stopPropagation();
                    if (checked) {
                      this.setState({
                        selectedOrders: [
                          ...this.state.selectedOrders,
                          ...filteredData,
                        ],
                      });
                    } else {
                      const copySelected = [...this.state.selectedOrders];
                      _.forEach(dataObjs, (obj) => {
                        const id = obj[ManageProcessOrderEnum.Id]
                          ? obj[ManageProcessOrderEnum.Id]
                          : obj._original[ManageProcessOrderEnum.Id];
                        const index = copySelected.indexOf(id);
                        if (index !== -1) {
                          copySelected.splice(index, 1);
                        }
                      });
                      this.setState({ selectedOrders: copySelected });
                    }
                  }}
                />
              </div>
            );
          },
          accessor: ManageProcessOrderEnum.Allowed,
          id: ManageProcessOrderEnum.Allowed,
          sortable: false,
          visibility: false,
          show: true,
          width: 40,
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: 'center' }}>
                <Checkbox
                  checked={
                    this.state.selectedOrders.indexOf(
                      original[ManageProcessOrderEnum.Id]
                    ) !== -1
                  }
                  onChange={() => {
                    const copyCheckState = [...this.state.selectedOrders];
                    copyCheckState.indexOf(
                      original[ManageProcessOrderEnum.Id]
                    ) !== -1
                      ? copyCheckState.splice(
                          copyCheckState.indexOf(
                            original[ManageProcessOrderEnum.Id]
                          ),
                          1
                        )
                      : copyCheckState.push(
                          original[ManageProcessOrderEnum.Id]
                        );
                    this.setState({ selectedOrders: copyCheckState });
                  }}
                />
              </div>
            );
          },
        },
        {
          Header: 'Order #',
          accessor: ManageProcessOrderEnum.Id,
          id: ManageProcessOrderEnum.Id,
          className: 'center-align',
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Site Id/Site',
          accessor: (row) => {
            return `${row[ManageProcessOrderEnum.SiteId]} ${
              row[ManageProcessOrderEnum.SiteName]
            }`;
          },
          id: `${ManageProcessOrderEnum.SiteId}_${ManageProcessOrderEnum.SiteName}`,
          ...ReactTableWrapperColumnProperties,
          minWidth: 150,
        },
        {
          Header: 'Order Date',
          accessor: ManageProcessOrderEnum.OrderDate,
          id: ManageProcessOrderEnum.OrderDate,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Delivery Date',
          accessor: ManageProcessOrderEnum.DeliveryDate,
          id: ManageProcessOrderEnum.DeliveryDate,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Status',
          accessor: ManageProcessOrderEnum.Status,
          id: ManageProcessOrderEnum.Status,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Comments',
          accessor: ManageProcessOrderEnum.Comments,
          id: ManageProcessOrderEnum.Comments,
          ...ReactTableWrapperColumnProperties,
        },
        {
          Header: 'Order Tag',
          accessor: ManageProcessOrderEnum.OrderTypeName,
          id: ManageProcessOrderEnum.OrderTypeName,
          ...ReactTableWrapperColumnProperties,
        },
        {
          resizable: false,
          width: 50,
          sortable: false,
          Cell: (gridProps) => {
            return GridContextMenu({
              gridProps,
              options: this.getMenuOptions(gridProps),
            });
          },
        },
      ],
      activeIndexes: [0, 1],
    };
    this.reactTable = React.createRef();
  }

  componentDidMount() {
    const {
      beginDT,
      endDT,
      site,
      getSiteList,
      orderTypeDetails,
      initialValues,
      getOrderList,
      getOrderTypes,
    } = this.props;

    getSiteList();

    const filtersOptions = {
      SiteId: site ? site : initialValues[ManageProcessOrderEnum.Site],
      FromTxnDt: beginDT
        ? moment(beginDT).format(DATE_FORMAT_FOR_SERVER)
        : initialValues[ManageProcessOrderEnum.BeginDT],
      ToTxnDt: endDT
        ? moment(endDT).format(DATE_FORMAT_FOR_SERVER)
        : initialValues[ManageProcessOrderEnum.EndDT],
      Status: '',
      SortColumn: this.defaultSort,
      Filter: [],
      OrderTypeDetails: orderTypeDetails
        ? orderTypeDetails
        : initialValues[ManageProcessOrderEnum.OrderTypeDetails],
    };
    getOrderList(filtersOptions);
    getOrderTypes();
  }

  componentDidUpdate(prevProps) {
    const {
      processMessageError,
      manageOrderListData,
      clearProcessMessage,
      setNotificationDialog,
      processDuplicateIds,
    } = this.props;
    if (
      manageOrderListData.Errors &&
      manageOrderListData.Errors.length &&
      prevProps.manageOrderListData.Errors !== manageOrderListData.Errors
    ) {
      NotificationMessage(manageOrderListData);
    }
    if (
      errorToast(this.props, prevProps, 'orderTypesError') ||
      errorToast(this.props, prevProps, 'cancelProcessError')
    ) {
      this.props.clearAllErrors();
    }
    if (
      processMessageError &&
      processMessageError !== prevProps.processMessageError
    ) {
      const dialog = {
        ...NOTIFICATION_DIALOG_MESSAGES.PROCESS_MESSAGE_ERROR,
        message: processMessageError,
      };
      setNotificationDialog(dialog);
      const cloneSelectedOrders = [...this.state.selectedOrders];
      if (processDuplicateIds.length > 0 && cloneSelectedOrders.length > 0) {
        _.remove(
          cloneSelectedOrders,
          (orderId) => processDuplicateIds.indexOf(orderId) !== -1
        );
      }
      this.setState({ selectedOrders: cloneSelectedOrders });
      clearProcessMessage();
    }
  }

  componentWillUnmount() {
    this.props.clearOrderGridData();
    this.props.resetTablePage(true);
  }

  setShowStatusOption = (value) => {
    const { beginDT, endDT, site, orderTypeDetails } = this.props;
    this.getFilterData(beginDT, endDT, site, value, orderTypeDetails);
    this.props.resetTablePage(true);
    this.emptySelectedOrders();
  };
  emptySelectedOrders = () => {
    this.setState({ selectedOrders: [] });
  };
  onChangeOfFromDT = (e, beginDate) => {
    this.selectFromDate(e, beginDate);
    this.emptySelectedOrders();
  };

  onChangeOfToDT = (e, endDate) => {
    this.selectToDate(e, endDate);
    this.emptySelectedOrders();
  };

  selectFromDate = (e, beginDate, prevDate) => {
    const { endDT, site, viewStatusOptions, orderTypeDetails } = this.props;
    if (beginDate !== prevDate) {
      this.props.setToDateMin(moment(beginDate, DATE_FORMAT_FOR_UI));
      this.getFilterData(
        beginDate,
        endDT,
        site,
        viewStatusOptions,
        orderTypeDetails
      );
      this.props.resetTablePage(true);
      this.emptySelectedOrders();
    }
  };

  selectToDate = (e, endDate, prevDate) => {
    const { beginDT, site, viewStatusOptions, orderTypeDetails } = this.props;
    if (endDate !== prevDate) {
      this.props.setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
      this.getFilterData(
        beginDT,
        endDate,
        site,
        viewStatusOptions,
        orderTypeDetails
      );
      this.props.resetTablePage(true);
      this.emptySelectedOrders();
    }
  };

  setSelectedSite = (newValue, prevValue) => {
    const { beginDT, endDT, viewStatusOptions, orderTypeDetails } = this.props;
    if (newValue !== prevValue) {
      this.getFilterData(
        beginDT,
        endDT,
        newValue,
        viewStatusOptions,
        orderTypeDetails
      );
      this.props.resetTablePage(true);
      this.emptySelectedOrders();
    }
  };

  clearFilters = () => {
    this.props.dispatch(reset(MANAGE_PROCESS_ORDER_FORM_NAME));
    const { initialValues } = this.props;
    this.props.setFromDateMax(moment().add(1, 'month'));
    this.props.setToDateMin(moment().subtract(1, 'month'));
    this.setState(
      {
        disableDateFields: false,
        selectedOrders: [],
        orderTypeDetails: [],
      },
      () => {
        this.getFilterData(
          initialValues[ManageProcessOrderEnum.BeginDT],
          initialValues[ManageProcessOrderEnum.EndDT],
          initialValues[ManageProcessOrderEnum.Site],
          initialValues[ManageProcessOrderEnum.ViewStatusOptions],
          initialValues[ManageProcessOrderEnum.OrderTypeDetails]
        );
        this.props.resetTablePage(true);
      }
    );
    this.completeReset();
  };

  completeReset = () => {
    this.props.resetForm(MANAGE_PROCESS_ORDER_FORM_NAME);
  };

  printTransactionGrid = (row) => {
    const {
      printOptionsValue,
      getPrintManageProcessOrderPreviewData,
    } = this.props;

    const selectedOrders = this.getFilteredSelectedOrders();
    let orderIds = [];
    if (row) {
      orderIds.push(row[ManageProcessOrderEnum.Id]);
    } else {
      orderIds = selectedOrders;
    }

    if (orderIds.length > 0) {
      const GroupBySelected = printOptionsValue;
      const sortType =
        GroupBySelected === ManageProcessOrderEnum.ItemCode
          ? PrintSortTypeEnum.ItemCode
          : PrintSortTypeEnum.ItemDescription;
      const { beginDT, endDT, site } = this.props;
      const DateFrom = moment(beginDT).format('YYYY/MM/DD');
      const DateTo = moment(endDT).format('YYYY/MM/DD');

      getPrintManageProcessOrderPreviewData({
        DateFrom,
        DateTo,
        Site: site,
        OrderIds: orderIds,
        Status: '',
        SortType: sortType,
      });
    }
  };

  getFilterData = (
    beginDT,
    endDT,
    site,
    viewStatusOptions,
    orderTypeDetails
  ) => {
    if (beginDT && endDT) {
      const filtersOptions = {
        SiteId: site,
        FromTxnDt: moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
        ToTxnDt: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        Status: '',
        SortColumn: this.defaultSort,
        Filter: [],
        OrderTypeDetails: orderTypeDetails,
      };
      this.props.getOrderList(filtersOptions).then(() => {
        this.props.resetTablePage(false);
      });
    }
  };

  showCloseModelForm = (row) => {
    const selectedOrdersTemp = this.getFilteredSelectedOrders();
    !selectedOrdersTemp.length &&
      selectedOrdersTemp.push(row[ManageProcessOrderEnum.Id]);
    const closedOrderedItem = getClosedOrderedItem(
      this.props.manageOrderListData.GetData,
      selectedOrdersTemp
    );

    if (closedOrderedItem.length) {
      this.setState({
        showCloseConfirm: !this.state.showCloseConfirm,
      });
      return;
    }

    this.setState({
      selectedOrders: selectedOrdersTemp,
      showCloseModel: !this.state.showCloseModel,
    });
  };

  closeOrderConfirm = () => {
    this.setState({
      showCloseConfirm: !this.state.showCloseConfirm,
    });
  };

  onAddItemClick = () => {
    this.props.history.push('/manageprocessorder/0/0/0/0');
  };

  onDeleteClick = (row) => {
    const selectedOrdersTemp = [...this.state.selectedOrders];
    !selectedOrdersTemp.length &&
      selectedOrdersTemp.push(row[ManageProcessOrderEnum.Id]);
    const closedOrderedItem = getClosedOrderedItem(
      this.props.manageOrderListData.GetData,
      selectedOrdersTemp
    );

    if (closedOrderedItem.length) {
      this.setState({
        showDeleteConfirm: !this.state.showDeleteConfirm,
      });
      return;
    }

    this.setState({
      selectedOrders: selectedOrdersTemp,
      showDeleteModel: !this.state.showDeleteModel,
    });
  };

  closeDeleteOrderConfirm = () => {
    this.setState({
      showDeleteConfirm: !this.state.showDeleteConfirm,
    });
  };

  handleDeleteDialog = (result) => {
    const {
      beginDT,
      endDT,
      site,
      viewStatusOptions,
      orderTypeDetails,
    } = this.props;
    if (result) {
      this.props.manageOrderDelete(this.state.selectedOrders).then((result) => {
        NotificationMessage(result.response.data);
        this.getFilterData(
          beginDT,
          endDT,
          site,
          viewStatusOptions,
          orderTypeDetails
        );
      });
    }

    this.setState({ showDeleteModel: false, selectedOrders: [] });
  };

  handleCloseDialog = (result) => {
    if (result) {
      const selectedOrders = this.getFilteredSelectedOrders();
      const filteredOrderList = _.filter(
        this.props.manageOrderListData.GetData,
        (order) => {
          return (
            selectedOrders.indexOf(order[ManageProcessOrderEnum.Id]) !== -1
          );
        }
      );

      this.props.manageOrderClose(filteredOrderList).then((result) => {
        const {
          beginDT,
          endDT,
          site,
          viewStatusOptions,
          orderTypeDetails,
        } = this.props;
        NotificationMessage(result.response.data);
        this.getFilterData(
          beginDT,
          endDT,
          site,
          viewStatusOptions,
          orderTypeDetails
        );
      });
    }

    this.setState({ showCloseModel: false, selectedOrders: [] });
  };
  onEditClick = (row) => {
    this.props.history.push(
      `/manageprocessorder/1/${row.SiteId}/${row.Id}/${moment(
        row.DeliveryDate
      ).format(DATE_FORMAT_FOR_SERVER)}`
    );
  };
  onDuplicateClick = (row) => {
    this.props.history.push(
      `/manageprocessorder/2/${row.SiteId}/${row.Id}/${moment(
        row.DeliveryDate
      ).format(DATE_FORMAT_FOR_SERVER)}`
    );
  };

  onProcessClick = (row) => {
    const selectedOrdersTemp = this.getFilteredSelectedOrders();
    !selectedOrdersTemp.length &&
      selectedOrdersTemp.push(row[ManageProcessOrderEnum.Id]);
    const closedOrderedItem = getClosedOrderedItem(
      this.props.manageOrderListData.GetData,
      selectedOrdersTemp
    );

    if (closedOrderedItem.length) {
      this.setState({
        showProcessConfirm: !this.state.showProcessConfirm,
      });
      return;
    }

    this.setState({
      selectedOrders: selectedOrdersTemp,
      showProcessModel: !this.state.showProcessModel,
    });
  };

  handleProcessDialog = (result) => {
    if (result) {
      const selectedOrders = this.getFilteredSelectedOrders();
      const filteredOrderList = _.filter(
        this.props.manageOrderListData.GetData,
        (order) => {
          return (
            selectedOrders.indexOf(order[ManageProcessOrderEnum.Id]) !== -1
          );
        }
      );
      this.props.manageProcessOrders(filteredOrderList);
    }

    this.setState({
      showProcessModel: false,
    });
  };

  processOrderConfirm = () => {
    this.setState({
      showProcessConfirm: !this.state.showProcessConfirm,
    });
  };

  getMenuOptions = (gridProps) => {
    const { setNotificationDialog } = this.props;
    const { row } = gridProps;
    let menuOptions = [
      {
        icon: 'pencil',
        text:
          row && row.Status === ManageProcessOrderStatusEnum.CLOSED
            ? 'View'
            : 'View/Edit',
        handler: this.onEditClick,
      },
      {
        icon: 'copy',
        text: 'Duplicate',
        handler: this.onDuplicateClick,
      },
      {
        icon: 'close',
        text: 'Close',
        handler: this.showCloseModelForm,
        disabledWhen: (row) =>
          row.Status === ManageProcessOrderStatusEnum.CLOSED,
      },
      {
        icon: 'plus square outline',
        text: 'Process',
        handler: this.onProcessClick,
        disabledWhen: (row) =>
          row.Status === ManageProcessOrderStatusEnum.CLOSED ||
          isPreferenceDisabled(
            PreferencesEnum.ProcessOrders,
            this.props.securityPreferences
          ),
      },
      {
        icon: 'clone',
        text: 'Consolidate',
        handler: this.onConsolidate,
        disabledWhen: (row) =>
          row.Status === ManageProcessOrderStatusEnum.CLOSED,
      },
      {
        icon: 'print',
        text: 'Print',
        handler: (row) => {
          setNotificationDialog({
            title: 'Sort By',
            message: (
              <ReduxFormButtonGroup
                options={ManageProcessOrderPrintOptions}
                formName={MANAGE_PROCESS_ORDER_FORM_NAME}
                fieldName={ManageProcessOrderEnum.PrintOptions}
                type={'button'}
              />
            ),
            showCancel: true,
            okButtonText: 'Print',
            functionsToRunOnOk: [() => this.printTransactionGrid(row)],
          });
        },
      },
      {
        icon: 'trash',
        text: 'Delete',
        className: 'danger',
        handler: this.onDeleteClick,
        disabledWhen: (row) =>
          row.Status === ManageProcessOrderStatusEnum.CLOSED,
      },
    ];
    const selectedOrders = this.getFilteredSelectedOrders();
    if (selectedOrders.length > 1) {
      menuOptions = [
        {
          icon: 'close',
          text: 'Close Selected',
          handler: this.showCloseModelForm,
        },
        {
          icon: 'plus square outline',
          text: 'Process Selected',
          handler: this.onProcessClick,
        },
        {
          icon: 'clone',
          text: 'Consolidate Selected',
          handler: this.onConsolidate,
        },
        {
          icon: 'print',
          text: 'Print Selected',
          handler: () => {
            setNotificationDialog({
              title: 'Sort By',
              message: (
                <ReduxFormButtonGroup
                  options={ManageProcessOrderPrintOptions}
                  formName={MANAGE_PROCESS_ORDER_FORM_NAME}
                  fieldName={ManageProcessOrderEnum.PrintOptions}
                  type={'button'}
                />
              ),
              showCancel: true,
              okButtonText: 'Print',
              functionsToRunOnOk: [() => this.printTransactionGrid()],
            });
          },
        },
        {
          icon: 'trash',
          text: 'Delete Selected',
          className: 'danger',
          handler: this.onDeleteClick,
        },
      ];
    }

    return menuOptions;
  };
  getConsolidateMenuOptions = () => {
    const menuOptions = [
      {
        icon: 'trash',
        text: 'Delete',
        className: 'danger',
        handler: this.onDeleteClick,
        disabledWhen: (row) =>
          row.Status === ManageProcessOrderStatusEnum.CLOSED,
      },
      {
        icon: 'close',
        text: 'Close',
        handler: this.showCloseModelForm,
        disabledWhen: (row) =>
          row.Status === ManageProcessOrderStatusEnum.CLOSED,
      },
      {
        icon: 'plus square outline',
        text: 'Process',
        handler: this.onProcessClick,
        disabledWhen: (row) =>
          row.Status === ManageProcessOrderStatusEnum.CLOSED,
      },
    ];
    return menuOptions;
  };
  fetchData = (state, instance) => {
    const {
      beginDT,
      endDT,
      site,
      viewStatusOptions,
      orderTypeDetails,
    } = this.props;
    this.getFilterData(
      beginDT,
      endDT,
      site,
      viewStatusOptions,
      orderTypeDetails,
      state
    );
  };
  onConsolidate = (row) => {
    const selectedOrdersTemp = this.getFilteredSelectedOrders();
    !selectedOrdersTemp.length &&
      selectedOrdersTemp.push(row[ManageProcessOrderEnum.Id]);
    const closedOrderedItem = getClosedOrderedItem(
      this.props.manageOrderListData.GetData,
      selectedOrdersTemp
    );

    if (closedOrderedItem.length) {
      this.setState({
        showConsolidateCloseOrderModal: !this.state
          .showConsolidateCloseOrderModal,
      });
      return;
    }

    this.setState({
      selectedOrders: selectedOrdersTemp,
      showConsolidateConfirm: !this.state.showConsolidateConfirm,
    });
  };
  handleConsolidate = (result) => {
    if (result) {
      const siteId =
        this.props.siteListData && this.props.siteListData.length
          ? this.props.siteListData[0].Id
          : 0;
      const model = {
        OrderIds: this.getFilteredSelectedOrders(),
        DeliveryDate: currentDate.format(DATE_FORMAT_FOR_SERVER),
        SiteId: siteId,
      };
      this.props.setConsolidateApiModelData(model);
      this.props.history.push(`/manageprocessorder/consolidate/${siteId}`);
    }
    this.setState({
      showConsolidateConfirm: false,
      selectedOrders: [],
    });
  };
  closeConsolidateOrderConfirm = () => {
    this.setState({
      showConsolidateCloseOrderModal: !this.state
        .showConsolidateCloseOrderModal,
    });
  };
  setOrderTypeDetails = (e, selectedOrderTypeDetails) => {
    const { beginDT, endDT, site, viewStatusOptions } = this.props;
    this.setState(
      {
        orderTypeDetails: selectedOrderTypeDetails,
      },
      () => {
        this.getFilterData(
          beginDT,
          endDT,
          site,
          viewStatusOptions,
          selectedOrderTypeDetails
        );
        this.props.resetTablePage(true);
      }
    );
  };
  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const cloneActiveIndexes = _.clone(this.state.activeIndexes);
    cloneActiveIndexes.indexOf(index) !== -1
      ? cloneActiveIndexes.splice(cloneActiveIndexes.indexOf(index), 1)
      : cloneActiveIndexes.push(index);
    this.setState({ activeIndexes: cloneActiveIndexes });
  };
  setExpandedState = (expanded) => {
    this.setState({ expanded });
  };
  getFilteredSelectedOrders = () => {
    const { manageOrderListData } = this.props;
    const { selectedOrders } = this.state;
    const checkedOrders = [];
    const dataObjs =
      this.reactTable && this.reactTable.current
        ? this.reactTable.current.getResolvedState()
        : { sortedData: manageOrderListData.GetData };
    _.forEach(dataObjs.sortedData, (obj) => {
      const id = obj[ManageProcessOrderEnum.Id]
        ? obj[ManageProcessOrderEnum.Id]
        : obj._original[ManageProcessOrderEnum.Id];
      if (selectedOrders.indexOf(id) !== -1) {
        checkedOrders.push(id);
      }
    });
    return checkedOrders;
  };

  onCreateOrderClick = () => {
    this.props.history.push('/manageprocessorder/0/0/0/0');
  };

  render() {
    const {
      manageOrderListData,
      siteListData,
      loading,
      closing,
      gridPreferenceSubmitting,
      gridPreferenceLoading,
      processLoading,
      processId,
      orderTypesLoading,
      orderTypesData,
      fromDateMax,
      toDateMin,
    } = this.props;
    return (
      <Fragment>
        <Filter title={'Orders'}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12} />
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New Order"
                  type={'button'}
                  onClick={this.onCreateOrderClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <ManageProcessOrderComponent
            onFetchData={this.fetchData}
            manageOrderListData={manageOrderListData.GetData}
            siteListData={siteListData}
            fromDateMax={fromDateMax}
            onChangeOfFromDT={this.onChangeOfFromDT}
            toDateMin={toDateMin}
            onChangeOfToDT={this.onChangeOfToDT}
            setSelectedSite={this.setSelectedSite}
            setShowStatusOption={this.setShowStatusOption}
            clearFilters={this.clearFilters}
            columns={this.state.columns}
            showCloseModel={this.state.showCloseModel}
            reactTableRef={this.reactTable}
            onAddItemClick={this.onAddItemClick}
            showDeleteModel={this.state.showDeleteModel}
            handleDeleteDialog={this.handleDeleteDialog}
            selectedOrders={this.state.selectedOrders}
            loading={loading}
            handleCloseDialog={this.handleCloseDialog}
            closing={closing}
            showDeleteConfirm={this.state.showDeleteConfirm}
            closeDeleteOrderConfirm={this.closeDeleteOrderConfirm}
            showCloseConfirm={this.state.showCloseConfirm}
            closeOrderConfirm={this.closeOrderConfirm}
            viewStatusOptionsValue={this.props.viewStatusOptions}
            printOptionsValue={this.props.printOptionsValue}
            showProcessConfirm={this.state.showProcessConfirm}
            showProcessModel={this.state.showProcessModel}
            handleProcessDialog={this.handleProcessDialog}
            processOrderConfirm={this.processOrderConfirm}
            gridPreferenceSubmitting={gridPreferenceSubmitting}
            gridPreferenceLoading={gridPreferenceLoading}
            history={this.props.history}
            printLoading={this.props.printLoading}
            processLoading={processLoading}
            processId={processId}
            showConsolidateCloseOrderModal={
              this.state.showConsolidateCloseOrderModal
            }
            showConsolidateConfirm={this.state.showConsolidateConfirm}
            handleConsolidate={this.handleConsolidate}
            closeConsolidateOrderConfirm={this.closeConsolidateOrderConfirm}
            orderTypesLoading={orderTypesLoading}
            orderTypesData={orderTypesData}
            setOrderTypeDetails={this.setOrderTypeDetails}
            handleCollapsePanelClick={this.handleCollapsePanelClick}
            activeIndexes={this.state.activeIndexes}
            expanded={this.state.expanded}
            setExpandedState={this.setExpandedState}
            resetPageOnDataChange={this.props.resetPageOnDataChange}
          />
        </Main>
      </Fragment>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  if (!values[ManageProcessOrderEnum.BeginDT]) {
    errors[ManageProcessOrderEnum.BeginDT] = 'Please select Begin Date';
  }
  if (!values[ManageProcessOrderEnum.EndDT]) {
    errors[ManageProcessOrderEnum.EndDT] = 'Please select End Date';
  }
  return errors;
};

const mapStateToProps = (state) => {
  const { manageProcessOrder, processOrder } = state.ManageOrderItemState;
  const { gridPreference } = state.CommonState;
  const { cancelProcessError } = state.GlobalUIState;

  const {
    manageOrderListData,
    siteListData,
    loading,
    printLoading,
    resetPageOnDataChange,
    fromDateMax,
    toDateMin,
  } = manageProcessOrder;
  const {
    processLoading,
    processMessageError,
    processDuplicateIds,
  } = processOrder;
  const selector = formValueSelector(MANAGE_PROCESS_ORDER_FORM_NAME);
  return {
    manageOrderListData: manageOrderListData,
    siteListData: siteListData,
    beginDT: selector(state, ManageProcessOrderEnum.BeginDT),
    endDT: selector(state, ManageProcessOrderEnum.EndDT),
    site: selector(state, ManageProcessOrderEnum.Site),
    viewStatusOptions: selector(
      state,
      ManageProcessOrderEnum.ViewStatusOptions
    ),
    printOptions: selector(state, ManageProcessOrderEnum.ItemCode),
    orderTypeDetails: selector(state, ManageProcessOrderEnum.OrderTypeDetails),
    loading: loading,
    printLoading: printLoading,
    processLoading: processLoading,
    closing: manageProcessOrder.closing,
    initialValues: {
      [ManageProcessOrderEnum.BeginDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [ManageProcessOrderEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [ManageProcessOrderEnum.Site]: '0',
      [ManageProcessOrderEnum.ViewStatusOptions]: ManageProcessOrderEnum.All,
      [ManageProcessOrderEnum.PrintOptions]: ManageProcessOrderEnum.ItemCode,
      [ManageProcessOrderEnum.OrderTypeDetails]: [],
    },
    printOptionsValue: selector(state, ManageProcessOrderEnum.PrintOptions),
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    processId: processOrder.processId,
    cancelProcessError: cancelProcessError,
    orderTypesData: CreateEditOrderSelectors.getOrderTypesResult(state),
    orderTypesLoading: CreateEditOrderSelectors.getOrderTypesLoading(state),
    orderTypesError: CreateEditOrderSelectors.getOrderTypesErrors(state),
    resetPageOnDataChange,
    fromDateMax,
    toDateMin,
    processMessageError,
    processDuplicateIds,
    securityPreferences: SecuritySelectors.getPreferences(state),
  };
};
const mapDispatchToProps = {
  clearOrderGridData,
  clearAllErrors,
  resetTablePage,
  getOrderList,
  getSiteList,
  manageOrderDelete,
  manageOrderClose,
  getPrintManageProcessOrderPreviewData,
  setToDateMin,
  setFromDateMax,
  manageProcessOrders,
  clearProcessMessage,
  resetForm,
  setConsolidateApiModelData,
  getOrderTypes: CreateEditOrderActions.getOrderTypes,
  setNotificationDialog,
  setYesNoDialogProps,
};

ManageProcessOrderContainer = reduxForm({
  validate,
  destroyOnUnmount: false,
  form: MANAGE_PROCESS_ORDER_FORM_NAME,
})(ManageProcessOrderContainer);

export const ManageProcessOrder = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageProcessOrderContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/containers/manageProcessOrderList/ManageProcessOrder.js